import Select from '@components/Select';

import { useAudioInputs } from '@providers/DevicesProvider';
import { useLogger } from '@providers/LoggerProvider';
import { useMeetingManager } from '@providers/MeetingProvider';
import type { ChangeEvent } from 'react';
import { Container } from './style';

const MicSelection = () => {
  const logger = useLogger();
  const { devices } = useAudioInputs();
  const meetingManager = useMeetingManager();

  const handleSelect = async (
    e: ChangeEvent<HTMLSelectElement>,
  ): Promise<void> => {
    try {
      const deviceId = e.target.value;
      await meetingManager.startAudioInputDevice(deviceId);
    } catch (error) {
      logger.error('MicSelection failed to select mic');
    }
  };

  return (
    <Container>
      <Select onChange={handleSelect}>
        {devices.map((device) => (
          <option key={device.deviceId} value={device.deviceId}>
            {device.label}
          </option>
        ))}
      </Select>
    </Container>
  );
};

export default MicSelection;
